// GENERATED by image pipeline — intrinsic dims + responsive variants for every asset.
export const IMG_MANIFEST = {
 "/assets/certs/fsai.png": {
  "h": 87,
  "w": 79
 },
 "/assets/certs/fssai.png": {
  "h": 221,
  "w": 450
 },
 "/assets/certs/ikeca.png": {
  "h": 67,
  "w": 113
 },
 "/assets/certs/nadca.png": {
  "h": 114,
  "w": 183
 },
 "/assets/certs/nfpa.png": {
  "h": 114,
  "w": 100
 },
 "/assets/clients/ahmedabad-one.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/aloft.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/apollo.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/avasa.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/best-western.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/bluefox.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/club-mahindra.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/conrad.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/country-inn.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/courtyard.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/crompton.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/crowne-plaza.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/db-mall.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/doubletree.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/fairfield.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/fazlani.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/fern.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/fortune.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/four-points.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/gateway.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/ginger.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/goldfinch.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/grand-hyatt.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/grand-mercure.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/green-park.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/hawthorn.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/hilton-garden-inn.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/hilton.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/hinduja.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/holiday-inn-express.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/holiday-inn.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/hp.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/hyatt-centric.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/hyatt-place.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/hyatt-regency.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/ibis.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/inorbit.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/irish-house.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/itc-hotels.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/jll.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/jw-marriott.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/kfc.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/le-meridien.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/leela.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/lemon-tree.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/lodha.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/lords.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/loreal.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/lulu-mall.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/marriott.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/memento.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/nocil.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/novotel.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/oakwood.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/oberoi-mall.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/oracle.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/park-hotels.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/phoenix-palassio.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/radisson.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/ramada.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/redfox.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/reliance.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/renaissance.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/ritz-carlton.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/royal-orchid.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/sarovar.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/sbi.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/seleqtions.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/sheraton.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/taj.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/union-bank.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/vedanta.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/vivanta.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/w-hotels.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/welcomhotel.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/clients/westin.webp": {
  "h": 240,
  "w": 480
 },
 "/assets/dcc-logo-400.webp": {
  "h": 66,
  "w": 400
 },
 "/assets/dcc-logo-800.webp": {
  "h": 132,
  "w": 800
 },
 "/assets/dcc/dcc-service-certificate.webp": {
  "h": 1333,
  "v": [
   640,
   1280
  ],
  "w": 2000
 },
 "/assets/accordible-logo.png": {
  "h": 150,
  "w": 1047
 },
 "/assets/dcc-logo.png": {  "h": 664,
  "v": [
   640,
   1280
  ],
  "w": 4016
 },
 "/assets/dcc-logo.webp": {
  "h": 664,
  "v": [
   640,
   1280
  ],
  "w": 4016
 },
 "/assets/dcc-mark.png": {
  "h": 256,
  "w": 256
 },
 "/assets/dcc/about-audit-1.webp": {
  "h": 1359,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/about-audit-2.webp": {
  "h": 906,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/ba-airduct-after.webp": {
  "h": 446,
  "w": 736
 },
 "/assets/dcc/ba-airduct-before.webp": {
  "h": 446,
  "w": 732
 },
 "/assets/dcc/ba-drain-after.webp": {
  "h": 446,
  "w": 745
 },
 "/assets/dcc/ba-drain-before.webp": {
  "h": 446,
  "w": 731
 },
 "/assets/dcc/ba-dryice-after.webp": {
  "h": 444,
  "w": 740
 },
 "/assets/dcc/ba-dryice-before.webp": {
  "h": 444,
  "w": 720
 },
 "/assets/dcc/ba-kitchen-after.webp": {
  "h": 447,
  "w": 738
 },
 "/assets/dcc/ba-kitchen-before.webp": {
  "h": 445,
  "w": 733
 },
 "/assets/dcc/ba-laundry-after.webp": {
  "h": 449,
  "w": 737
 },
 "/assets/dcc/ba-laundry-before.webp": {
  "h": 449,
  "w": 726
 },
 "/assets/dcc/careers-apply.webp": {
  "h": 1077,
  "v": [
   640,
   1280
  ],
  "w": 1920
 },
 "/assets/dcc/ceiling-access.webp": {
  "h": 1600,
  "v": [
   640,
   1280
  ],
  "w": 1600
 },
 "/assets/dcc/crew-execution.webp": {
  "h": 1800,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/crew-portrait.webp": {
  "h": 897,
  "v": [
   640,
   1280
  ],
  "w": 1600
 },
 "/assets/dcc/crew-ready.webp": {
  "h": 738,
  "v": [
   640,
   1280
  ],
  "w": 1600
 },
 "/assets/dcc/dcc-controlled-cleaning.webp": {
  "h": 898,
  "v": [
   640,
   1280
  ],
  "w": 1600
 },
 "/assets/dcc/dcc-facility-survey.webp": {
  "h": 1010,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/dcc-kitchen-execution.webp": {
  "h": 1800,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/dcc-kitchen-survey.webp": {
  "h": 1655,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/dcc-site-preparation.webp": {
  "h": 898,
  "v": [
   640,
   1280
  ],
  "w": 1600
 },
 "/assets/dcc/degreaser-prep.webp": {
  "h": 897,
  "v": [
   640,
   1280
  ],
  "w": 1600
 },
 "/assets/dcc/drain-vac.webp": {
  "h": 826,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/dryice-action.webp": {
  "h": 897,
  "v": [
   640,
   1280
  ],
  "w": 1600
 },
 "/assets/dcc/dryice-panel.webp": {
  "h": 820,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/duct-condition-after.webp": {
  "h": 941,
  "w": 836
 },
 "/assets/dcc/ev-after.webp": {
  "h": 1077,
  "v": [
   640,
   1280
  ],
  "w": 1920
 },
 "/assets/dcc/ev-before.webp": {
  "h": 1077,
  "v": [
   640,
   1280
  ],
  "w": 1920
 },
 "/assets/dcc/ev-checklist.webp": {
  "h": 1077,
  "v": [
   640,
   1280
  ],
  "w": 1920
 },
 "/assets/dcc/ev-execution.webp": {
  "h": 1004,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/ev-handover.webp": {
  "h": 1077,
  "v": [
   640,
   1280
  ],
  "w": 1920
 },
 "/assets/dcc/ev-inspection.webp": {
  "h": 1010,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/grease-drain.webp": {
  "h": 1009,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/hero-main.webp": {
  "h": 828,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/ind-commercial-buildings.webp": {
  "h": 1800,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/ind-commercial-kitchens.webp": {
  "h": 1800,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/ind-healthcare.webp": {
  "h": 1800,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/ind-hospitals.webp": {
  "h": 1800,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/ind-hotels.webp": {
  "h": 1800,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/ind-industrial.webp": {
  "h": 1800,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/ind-institutional.webp": {
  "h": 1800,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/ind-it-parks.webp": {
  "h": 1800,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/ind-malls.webp": {
  "h": 1800,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/ind-offices.webp": {
  "h": 1800,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/ind-pharma.webp": {
  "h": 1800,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/ind-portfolios.webp": {
  "h": 1800,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/ind-qsr.webp": {
  "h": 1800,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/ind-restaurants.webp": {
  "h": 1800,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/ind-retail.webp": {
  "h": 1800,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/ind2-commercial-buildings.webp": {
  "h": 1012,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/ind2-commercial-kitchens.webp": {
  "h": 900,
  "v": [
   640,
   1280
  ],
  "w": 1600
 },
 "/assets/dcc/ind2-healthcare.webp": {
  "h": 900,
  "v": [
   640,
   1280
  ],
  "w": 1600
 },
 "/assets/dcc/ind2-hospitals.webp": {
  "h": 1012,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/ind2-hotels.webp": {
  "h": 1012,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/ind2-industrial.webp": {
  "h": 1012,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/ind2-institutional.webp": {
  "h": 1012,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/ind2-it-parks.webp": {
  "h": 1012,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/ind2-malls.webp": {
  "h": 900,
  "v": [
   640,
   1280
  ],
  "w": 1600
 },
 "/assets/dcc/ind2-offices.webp": {
  "h": 900,
  "v": [
   640,
   1280
  ],
  "w": 1600
 },
 "/assets/dcc/ind2-pharma.webp": {
  "h": 900,
  "v": [
   640,
   1280
  ],
  "w": 1600
 },
 "/assets/dcc/ind2-portfolios.webp": {
  "h": 1012,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/ind2-qsr.webp": {
  "h": 900,
  "v": [
   640,
   1280
  ],
  "w": 1600
 },
 "/assets/dcc/ind2-restaurants.webp": {
  "h": 900,
  "v": [
   640,
   1280
  ],
  "w": 1600
 },
 "/assets/dcc/ind2-retail.webp": {
  "h": 1012,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/inspect-panel.webp": {
  "h": 1010,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/kitchen-prep.webp": {
  "h": 1654,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/laundry-duct.webp": {
  "h": 1600,
  "v": [
   640,
   1280
  ],
  "w": 1600
 },
 "/assets/dcc/laundry-inspect.webp": {
  "h": 733,
  "v": [
   640,
   1280
  ],
  "w": 1600
 },
 "/assets/dcc/plant-robot.webp": {
  "h": 834,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/robot-tech.webp": {
  "h": 1122,
  "v": [
   640,
   1280
  ],
  "w": 1600
 },
 "/assets/dcc/svc-drain-grease.webp": {
  "h": 825,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/svc-dry-ice.webp": {
  "h": 820,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/svc-kitchen-exhaust.webp": {
  "h": 830,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/svc-laundry-duct.webp": {
  "h": 824,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/svc-robotic-air-duct.webp": {
  "h": 1114,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/svc2-drain.webp": {
  "h": 1694,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/svc2-dryice.webp": {
  "h": 1694,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/svc2-kitchen.webp": {
  "h": 1694,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/svc2-laundry.webp": {
  "h": 1694,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/svc2-robot.webp": {
  "h": 1694,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/work-hospital-hvac.webp": {
  "h": 1077,
  "v": [
   640,
   1280
  ],
  "w": 1920
 },
 "/assets/dcc/work-hotel-ahu.webp": {
  "h": 1077,
  "v": [
   640,
   1280
  ],
  "w": 1920
 },
 "/assets/dcc/work-qsr-exhaust.webp": {
  "h": 1004,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/work2-itpark.webp": {
  "h": 1011,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/work2-mall.webp": {
  "h": 1010,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/dcc/work2-resort.webp": {
  "h": 1004,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/india-map-dark.webp": {
  "h": 1615,
  "v": [
   640,
   1280
  ],
  "w": 1500
 },
 "/assets/insights/commercial-drain-grease-trap.webp": {
  "h": 1009,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/insights/kitchen-team-reviewing-tablet.webp": {
  "h": 610,
  "v": [
   640,
   1280
  ],
  "w": 1600
 },
 "/assets/insights/real-site-duct-work.webp": {
  "h": 1654,
  "v": [
   640,
   1280
  ],
  "w": 1800
 },
 "/assets/og-default.jpg": {
  "h": 630,
  "w": 1200
 },
 "/assets/testimonials/01_syed_shamshuddin.webp": {
  "h": 800,
  "w": 800
 },
 "/assets/testimonials/01_vijay_dudhatra.webp": {
  "h": 575,
  "w": 575
 },
 "/assets/testimonials/02_navaneethan_r.webp": {
  "h": 577,
  "w": 577
 },
 "/assets/testimonials/03_mahadev_ghulnawar.webp": {
  "h": 800,
  "w": 800
 },
 "/assets/testimonials/03_sonaram_choudhary.webp": {
  "h": 800,
  "w": 800
 },
 "/assets/testimonials/04_jamiroddin_kazi.webp": {
  "h": 800,
  "w": 800
 },
 "/assets/testimonials/05_shubham_awasthi.webp": {
  "h": 800,
  "w": 800
 },
 "/assets/testimonials/06_joseph_fernandes.webp": {
  "h": 800,
  "w": 800
 },
 "/assets/testimonials/07_kalpesh_sonagra.webp": {
  "h": 800,
  "w": 800
 },
 "/assets/testimonials/08_himanshu_shah.webp": {
  "h": 1333,
  "w": 1000
 },
 "/assets/testimonials/logo_04_jamiroddin_kazi.webp": {
  "h": 230,
  "w": 496
 }
};
